import { ReactNode } from 'react';

export const ChapterContent = ({ children, isLandscape, isMobile }: { children: ReactNode; isLandscape: boolean; isMobile: boolean }) => (
    <div
        id="chapters"
        className={`relative ${isMobile ? (isLandscape ? 'h-full min-h-0 row-span-full' : 'h-full min-h-[30vh] row-span-full') : 'max-h-[50dvh]'} bg-white`}
    >
        {children}
    </div>
);
